export const GET_SUPPORTS = "GET_SUPPORTS";
export const GET_SUPPORT_BY_ID = "GET_SUPPORT_BY_ID";
export const UPDATE_SUPPORT = "UPDATE_SUPPORT";
export const DELETE_SUPPORT = "DELETE_SUPPORT";
export const CREATE_SUPPORT = "CREATE_SUPPORT";
